import React, { useState, useEffect } from "react";
import mesurementImg from "../../assets/Measurment-IMG.png";
import "./MeasurementForm.css";
import { useSearchParams, useNavigate } from "react-router-dom";
import base_url from "../../api";

const MeasurementForm = () => {
  const [measurements, setMeasurements] = useState({
    1: "", 2: "", 3: "", 4: "", 5: "", 6: "",
    7: "", 8: "", 9: "", 10: "", 11: "", 12: "", 13: ""
  });

  const [errors, setErrors] = useState({});
  const [showError, setShowError] = useState(false);
  const [lookDetails, setLookDetails] = useState(null);
  const [loadingLook, setLoadingLook] = useState(true);
  const [lookError, setLookError] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [hoveredMeasurement, setHoveredMeasurement] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMeasurements({ ...measurements, [name]: value });
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
    // Hide general error message when user starts filling fields
    if (showError) {
      setShowError(false);
    }
  };
const [searchParams] = useSearchParams();

const orderNo = searchParams.get("orderNo");
const recipientEmail = searchParams.get("recipientEmail");
const adminEmail = searchParams.get("adminEmail");

// Fetch look details when component mounts
useEffect(() => {
  if (orderNo && recipientEmail) {
    fetchLookDetails();
  } else {
    setLoadingLook(false);
    setLookError("Missing required parameters. Please use the link from your email.");
  }
}, [orderNo, recipientEmail]);

const fetchLookDetails = async () => {
  try {
    setLoadingLook(true);
    setLookError(null);
    const res = await fetch(`${base_url}/measurements/recipient-look/${orderNo}/${encodeURIComponent(recipientEmail)}`);
    const data = await res.json();
    
    if (res.ok && data.success) {
      // Handle image URL - if it's a relative path starting with /apis/, construct full URL
      let lookData = { ...data.look };
      if (lookData.image && lookData.image.startsWith("/apis/")) {
        const serverBase = base_url.replace(/\/apis\/?$/, "");
        lookData.image = `${serverBase}${lookData.image}`;
      }
      setLookDetails(lookData);
    } else {
      setLookError(data.error || "Failed to load measurement form details. Please check your email link or contact support.");
      console.error("Error fetching look details:", data.error);
    }
  } catch (err) {
    setLookError("Network error. Please check your internet connection and try again.");
    console.error("Error fetching look details:", err);
  } finally {
    setLoadingLook(false);
  }
};

  const measurementLabels = {
    12: "Shoulder to Knee",
    3: "Around Chest",
    4: "Around Waist",
    5: "Around upper Hips",
    6: "Around lower Hips",
    9: "Sleeve Length",
    11: "Bicep",
    2: "Shoulder Width",
    1: "Around Neck",
    13: "Waist to Heel",
    7: "Around Knee",
    8: "Around Ankle",
    10: "Height",
  };

 
  const markers = [
    { num: "12", top: "50%", left: "87%" },
    { num: "3", top: "28%", left: "50%" },
    
    { num: "4", top: "35%", left: "50%" },
    { num: "5", top: "42%", left: "50%" },
    { num: "6", top: "50%", left: "50%" },
    { num: "9", top: "38%", left: "17%" },
    { num: "11", top: "28%", left: "65%" },
    { num: "2", top: "22%", left: "50%" },
    { num: "1", top: "15%", left: "50%" },
    { num: "13", top: "65%", left: "72%" },
    { num: "7", top: "79%", left: "41%" },
    { num: "8", top: "92%", left: "40%" },
    { num: "10", top: "50%", left: "8%" },
  ];


  // Helper: smooth scroll to a specific input by id
  const scrollToField = (fieldId) => {
    const errorElement = document.getElementById(fieldId);
    if (errorElement) {
      const rect = errorElement.getBoundingClientRect();
      const offset = window.pageYOffset || document.documentElement.scrollTop;
      const targetY = rect.top + offset - 140; // small offset for headers
      window.scrollTo({ top: targetY, behavior: "smooth" });
      errorElement.focus();
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let firstErrorKey = null;

    Object.keys(measurements).forEach((key) => {
      const value = measurements[key].trim();
      if (!value) {
        newErrors[key] = "This field is required";
        if (!firstErrorKey) firstErrorKey = key;
      } else if (isNaN(value) || parseFloat(value) <= 0) {
        newErrors[key] = "Please enter a valid positive number";
        if (!firstErrorKey) firstErrorKey = key;
      } else {
        const numValue = parseFloat(value);
        // Validate reasonable measurement ranges (in inches)
        if (numValue > 200) {
          newErrors[key] = "Measurement seems too large. Please check your value.";
          if (!firstErrorKey) firstErrorKey = key;
        } else if (numValue < 0.1) {
          newErrors[key] = "Measurement seems too small. Please check your value.";
          if (!firstErrorKey) firstErrorKey = key;
        }
      }
    });

    setErrors(newErrors);
    return { isValid: !firstErrorKey, firstErrorKey };
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Validate all fields before submission
  const { isValid, firstErrorKey } = validateForm();
  if (!isValid) {
    setShowError(true);
    if (firstErrorKey) {
      // Scroll directly to the first invalid field
      scrollToField(firstErrorKey);
    }
    return;
  }

  setShowError(false);
  setErrors({});

  const measurementArray = Object.keys(measurements).map((key) => ({
    key,
    label: measurementLabels[key],
    value: measurements[key],
  }));

  const payload = {
    orderNo,
    recipientEmail, // already decoded
    adminEmail,     // already decoded
    measurements: measurementArray,
  };

  console.log("Payload:", payload);

  const res = await fetch(`${base_url}/measurements`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (res.status === 409) {
    alert("Measurements already submitted");
    return;
  }

  if (data.success) {
    setShowSuccessModal(true);
  } else {
    alert(data.error || "Failed to submit measurements. Please try again.");
  }
};

const handleModalClose = () => {
  setShowSuccessModal(false);
  navigate("/");
};



  return (
    <div className="mf-page-body">
      {loadingLook ? (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '60vh',
          flexDirection: 'column',
          gap: '20px'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #b5651d',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p style={{ color: '#666', fontSize: '16px' }}>Loading measurement form...</p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      ) : lookError ? (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '60vh',
          flexDirection: 'column',
          gap: '20px',
          padding: '40px 20px'
        }}>
          <div style={{
            background: '#fff3cd',
            border: '2px solid #ffc107',
            borderRadius: '12px',
            padding: '30px',
            maxWidth: '600px',
            textAlign: 'center'
          }}>
            <h2 style={{ color: '#856404', margin: '0 0 15px 0' }}>⚠️ Error Loading Form</h2>
            <p style={{ color: '#856404', margin: '0 0 20px 0', fontSize: '16px' }}>{lookError}</p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 24px',
                background: '#b5651d',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              Retry
            </button>
          </div>
        </div>
      ) : (
      <div className="mf-form-wrapper">
        {/* Left Side - Input Form */}
        <div className="mf-form-left">
          {/* Product Image and Details Section */}
          {lookDetails && (
            <div className="mf-product-preview-section">
              <h2>Your Custom Outfit</h2>
              <div className="mf-product-preview-content">
                {lookDetails.image && (
                  <div className="mf-product-image-container">
                    <img 
                      src={lookDetails.image} 
                      alt={lookDetails.look_name || "Custom Outfit"} 
                      className="mf-product-image"
                    />
                    {/* Hover indicator synced with measurement diagram */}
                    {hoveredMeasurement && (() => {
                      const marker = markers.find((m) => m.num === hoveredMeasurement);
                      if (!marker) return null;
                      return (
                        <div
                          className="mf-marker mf-product-marker"
                          style={{ top: marker.top, left: marker.left }}
                        >
                          {hoveredMeasurement}
                        </div>
                      );
                    })()}
                  </div>
                )}
                <div className="mf-product-details-info">
                  <h3>{lookDetails.look_name || "Custom Look"}</h3>
                  {lookDetails.look_title && (
                    <p className="mf-product-subtitle">{lookDetails.look_title}</p>
                  )}
                  <div className="mf-product-specs">
                    <p><strong>Kurta:</strong> {lookDetails.kurta_color} • {lookDetails.kurta_fabric}</p>
                    <p><strong>Pajama:</strong> {lookDetails.pajama_color} • {lookDetails.pajama_fabric}</p>
                    <p><strong>Shawl:</strong> {lookDetails.shawl}</p>
                    <p><strong>Quantity:</strong> {lookDetails.quantity} outfit(s)</p>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <div className="mf-measurement-form-section">
            <h2>Measurement Form</h2>
            <div className="mf-instructions">
              <strong>📏 Important Instructions</strong>
              <div>
                • Measure yourself just prior to placing an order.<br />
                • Fill all measurements in inches.<br />
                • Have yourself measured by a professional if possible.<br />
                • Do not make extra allowance or pull tape too tight.<br />
                • Send complete measurements using your Name and Email address.
              </div>
            </div>

            {showError && (
              <div className="mf-error-message">
                <strong>⚠️ Please fill all required values before submission</strong>
                <p>All measurement fields are required. Please check the fields highlighted in red.</p>
              </div>
            )}
            <form className="mf-measurement-form" onSubmit={handleSubmit}>
              {Object.keys(measurements).map((key) => (
                <div key={key} className="mf-input-wrapper">
                  <label
                    htmlFor={key}
                    data-number={key}
                    onMouseEnter={() => setHoveredMeasurement(key)}
                    onMouseLeave={() => setHoveredMeasurement(null)}
                  >
                    {measurementLabels[key]}
                    <span className="mf-required-asterisk"> *</span>
                  </label>
                <input
                  id={key}
                  name={key}
                  value={measurements[key]}
                  onChange={handleChange}
                  placeholder={`Enter ${measurementLabels[key]} (in inches)`}
                  className={errors[key] ? "mf-input-error" : ""}
                />
                {errors[key] && (
                  <span className="mf-field-error">{errors[key]}</span>
                )}
              </div>
            ))}
              <button type="submit" className="mf-submit-btn">
                Submit Measurements
              </button>
            </form>
          </div>
        </div>

        {/* Right Side - Image with Markers */}
        <div className="mf-form-right">
          <div className="mf-guide-section">
            <h3>Measurement Guide</h3>
          <div
            className="mf-measurement-img"
            style={{
              backgroundImage: `url(${mesurementImg})`,
              position: "relative",
            }}
            >
            {markers.map((m, i) => (
              <div
                key={i}
                className={`mf-marker ${measurements[m.num] ? "mf-marker-completed" : ""}`}
                style={{ top: m.top, left: m.left }}
                onMouseEnter={() => setHoveredMeasurement(m.num)}
                onMouseLeave={() => setHoveredMeasurement(null)}
                onClick={() => {
                  scrollToField(m.num);
                }}
              >
                {measurements[m.num] || m.num}
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="mf-modal-overlay" onClick={handleModalClose}>
          <div className="mf-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="mf-modal-header">
              <h2>✅ Thank You!</h2>
            </div>
            <div className="mf-modal-body">
              <p>Thank you for submitting your measurements.</p>
              <p>Soon you will get a mail of your measurement.</p>
            </div>
            <div className="mf-modal-footer">
              <button className="mf-modal-ok-btn" onClick={handleModalClose}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MeasurementForm;
